import React from 'react';
import classnames from 'classnames';
import {Button} from '@br/br-components';

import ErrorMessages from '../atoms/errorMessages';

const REGEX_TEN_DIGITS = /^\d{10}$/;

class PhoneInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true,
      errors: this.props.errors || [],
      value: '' || this.props.value,
      loading: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  moveInput(elem, direction) {
    const nextElement =
      direction === 'backwards' ? elem.previousElementSibling : elem.nextElementSibling;
    // nextElement will be null if there is no next/prev sibling element
    if (nextElement && nextElement.nodeName === 'INPUT') {
      nextElement.focus();
      nextElement.setSelectionRange(1, 1);
    }
  }

  onChange(event) {
    const value = event.target.value.trim();
    const isPhoneValid = REGEX_TEN_DIGITS.test(value);

    this.setState({
      isValid: isPhoneValid,
      value,
    });
  }

  onSubmit(event) {
    event.preventDefault();
    this.setState(
      {
        loading: true,
      },
      () => {
        const NON_DECIMAL = /\D/;
        const value = this.state.value;

        if (this.props.onSubmit) {
          if (NON_DECIMAL.test(value)) {
            // if it contains non-numeric characters...
            return this.setState({errors: ['Please enter a valid phone number']});
          }
          return this.props.onSubmit(event, value);
        }

        return null;
      }
    );
  }

  render() {
    const classes = classnames({
      molecule: true,
      phoneInput: true,
    });

    const {loading, isValid, value} = this.state;
    const {legalDisclaimer} = this.props;

    return (
      <form className={classes} onSubmit={this.onSubmit}>
        <h2>{this.props.title}</h2>
        <p className="smsText">We'll send you an SMS verification code.</p>
        +1
        <input
          ref={(elem) => {
            this._phoneInput = elem;
          }}
          name="telephone"
          type="number"
          inputMode="numeric"
          pattern="[0-9]*"
          value={value}
          onChange={this.onChange}
          required={true}
          maxLength={10}
          title="telephone number"
          autoFocus={true}
        />
        <ErrorMessages errors={this.props.errors} errorSet="phone" />
        {legalDisclaimer && <div className="legalDisclaimer">{legalDisclaimer}</div>}
        <Button type="submit" disabled={!isValid || loading} loading={loading}>
          {this.props.buttonText}
        </Button>
        {this.props.children}
      </form>
    );
  }
}

PhoneInput.defaultProps = {
  buttonText: 'Next',
  title: 'Please Provide Your Phone Number',
  value: '',
};

export default PhoneInput;
